<div id="content">
  <p class="mat-h1 titulo">{{titulo}}</p>
  <p class="mat-body mensagem">{{mensagem}}</p>
  <p class="mat-body-strong mensagem">{{mensagemBold}}</p>

  <div class="container-botoes inline-element">
    <button mat-button class="button btn-voltar" [mat-dialog-close]="true" (click)="cancelar()">
      {{textoBtnCancelar}}
    </button>
    @if (mostrarBtnConfirmar) {
      <button mat-stroked-button class="button btn-acao" [mat-dialog-close]="true"
        [ngStyle]="{'background-color': btnBackgroundColor}" (click)="confirmar()">
        {{textoBtnConfirmacao}}
      </button>
    }
  </div>
</div>